import React, { useState } from 'react'
import { Button, Icon, Loader, Popup } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import createAction from '../../../../../../../redux/actions/createAction'
import {
    FETCH_PROOF_OF_DELIVERY_DOWNLOAD
} from '../../../../../../../redux/actions/actionTypes'

const DownloadPaperwork = props => {
    const { podS3Key } = props
    const { t: translate } = useTranslation('common')
    const [response, setResponse] = useState(null)
    const [loadingFailed, setLoadingFailed] = useState(false)
    const [pdfLoaded, setPdfLoaded] = useState(false)
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()

    const download = responseData => {
        if (responseData) {
            const dataURItoBlob = (dataURI, mimeType) => {
                const byteString = window.atob(dataURI)
                const arrayBuffer = new ArrayBuffer(byteString.length)
                const int8Array = new Uint8Array(arrayBuffer)
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < byteString.length; i++) {
                    int8Array[i] = byteString.charCodeAt(i)
                }
                return new Blob([int8Array], { type: mimeType })
            }
            try {
                const fileExtension = podS3Key.split('.').pop().toLowerCase()
                let mimeType
                switch (fileExtension) {
                    case 'tiff':
                    case 'tif':
                        mimeType = 'image/tiff'
                        break
                    case 'png':
                        mimeType = 'image/png'
                        break
                    case 'jpg':
                    case 'jpeg':
                        mimeType = 'image/jpeg'
                        break
                    default:
                        mimeType = 'application/pdf'
                }
                const blob = dataURItoBlob(responseData, mimeType)
                const url = URL.createObjectURL(blob)
                const anchor = document.createElement('a')
                anchor.download = `Proof Of Delivery.${fileExtension}`
                anchor.href = url
                anchor.click()
                if (!response) {
                    setResponse(responseData)
                }
                setPdfLoaded(true)
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err)
                setLoadingFailed(true)
            }
        }
    }
    const handleClick = () => {
        setLoading(true)
        setLoadingFailed(false)
        setPdfLoaded(false)
        dispatch(createAction(
            FETCH_PROOF_OF_DELIVERY_DOWNLOAD,
            {
                podS3Key,
                onFailure: () => {
                    setLoadingFailed(true)
                    setLoading(false)
                    setResponse(null)
                },
                onSuccess: responseData => {
                    setLoadingFailed(false)
                    setLoading(false)
                    download(responseData)
                },
            },
        ))
    }

    return (
        <React.Fragment>
            {podS3Key &&
                <Popup
                    pinned={loadingFailed}
                    content={loadingFailed ? translate('POD download failed. Try again.') : pdfLoaded ? translate('PDF downloaded') : translate('Click to Download')}
                    trigger={
                        <Button
                            color="green"
                            type="button"
                            disabled={loading}
                            onClick={() => (response ? download(response) : handleClick())}
                        >
                            <Button.Content visible>
                                <span>{translate('Proof of Delivery')}</span>
                                {!loading && <Icon name="download" style={{ margin: '0 0 0 0.5rem' }}/>}
                                {loading &&
                                    <Loader
                                        inline
                                        active={loading}
                                        size="mini"
                                        style={{ margin: '0 0 0 0.5rem' }}
                                    />}
                            </Button.Content>
                        </Button>
                    }
                />}
        </React.Fragment>
    )
}

export default DownloadPaperwork
